import { post } from '../utility';

export const getStatus = ({ callback }) => {
	post({
		method: 'inventoryBalanceStatus.get',
		params: {},
		callback,
	});
};

export const searchBalances = ({
	periodYear,
	periodMonth,
	terminalIds,
	productTypes,
	onlyWithWarnings,
	limit,
	callback,
}) => {
	post({
		method: 'inventoryBalanceStatus.balances.search',
		params: { periodYear, periodMonth, terminalIds, productTypes, onlyWithWarnings, limit },
		callback,
	});
};

export const searchQueue = ({
	statuses,
	terminalIds,
	triggerType,
	periodYear,
	periodMonth,
	limit,
	callback,
}) => {
	post({
		method: 'inventoryBalanceStatus.queue.search',
		params: { statuses, terminalIds, triggerType, periodYear, periodMonth, limit },
		callback,
	});
};
